import React from "react";
import Logo_img from "../../assets/images/shb-logo-letter.svg";
import { Image } from "react-bootstrap";

const LetterLayout = ({ children }) => {
    return (
        <div id="letter-guarantee" className="content-container">
            <div className="header">
                <Image src={Logo_img} className="img-fluid" />
            </div>
            <div className="letter-content">
                {children}
            </div>
        </div>
    )
}

export default LetterLayout